/* Vyhledávání v hlavičce – lupa rozbalí panel s formulářem.
 * Bez JS zůstane lupa běžným odkazem na stránku výsledků (viz navbar.php). */
(function () {
	function init() {
		var btn = document.getElementById('nav-search-toggle');
		var panel = document.getElementById('nav-search-panel');
		if (!btn || !panel) return;

		// Panel existuje => lupa přestává být prostý odkaz a přepíná ho.
		btn.addEventListener('click', function (e) {
			e.preventDefault();
			var open = panel.classList.toggle('open');
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.setAttribute('aria-hidden', open ? 'false' : 'true');
			if (open) {
				var input = panel.querySelector('input[name="s"]');
				if (input) input.focus();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && panel.classList.contains('open')) {
				panel.classList.remove('open');
				btn.setAttribute('aria-expanded', 'false');
				panel.setAttribute('aria-hidden', 'true');
				btn.focus();
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
